'use client';

import type { FC } from 'react';
import { Credits } from './Credits';

interface AmountSentenceProps {
  template: string;
  amount: number;
  className?: string;
  iconSize?: number;
}

// WHY: the {{amount}} slot is not always at the end — Uzbek puts the verb AFTER the sum; text+number concatenation broke
// word order (#323)
export const AmountSentence: FC<AmountSentenceProps> = ({
  template,
  amount,
  className,
  iconSize = 13,
}) => {
  const [before, after] = template.split('{{amount}}');
  return (
    <span className={className}>
      {before}
      <Credits amount={amount} iconSize={iconSize} align="baseline" />
      {after}
    </span>
  );
};
